import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

export const useShareWithTeamDialogStyles = makeStyles<Theme>((theme) => ({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0, 2),
    minHeight: 42
  },
  tab: {
    minHeight: 42,
    minWidth: 'auto',
    marginRight: theme.spacing(3),
    padding: theme.spacing(1, 0),
    textTransform: 'none',
    ...theme.typography.body1
  },
  crewGrid: {
    marginTop: theme.spacing(0.5)
  },
  crewTile: {
    display: 'flex',
    alignItems: 'stretch',
    border: `1px solid ${theme.paintscout.palette.brand.Neutral.P85}`,
    borderRadius: theme.borderRadius.md,
    overflow: 'hidden',
    cursor: 'pointer',
    backgroundColor: theme.palette.common.white,
    transition: 'background-color 0.15s, border-color 0.15s',
    minHeight: 69,
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  crewTileSelected: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.paintscout.palette.secondary[260].C95,
    '&:hover': {
      backgroundColor: theme.paintscout.palette.secondary[260].C90
    }
  },
  crewTileAccent: {
    width: 7,
    flexShrink: 0,
    borderTopLeftRadius: 3,
    borderBottomLeftRadius: 3
  },
  crewTileContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(0.25),
    padding: theme.spacing(1.5, 2),
    flex: 1,
    minWidth: 0
  },
  crewTileName: {
    ...theme.typography.body1,
    color: theme.palette.text.primary,
    lineHeight: '22px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  crewTileMembers: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  emptyText: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(2, 0)
  }
}))
